<template>
  <fin-data-loader :resolver="loadEntry">
    <template #content>
      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   fluid>
        <v-row v-if="academyEntry">
          <v-col>
            <h1 class="mt-6">{{ academyEntry.data.title[0].text }}</h1>
            <p class="intro mt-3">{{ academyEntry.data.introduction[0].text }}</p>
            <v-img :alt="academyEntry.data.poster_img.alt"
                   :src="academyEntry.data.poster_img.url"
                   class="mt-3 mb-7"
                   style="max-width: 50%">
              <v-layout slot="placeholder" align-center fill-height justify-center ma-0>
                <img :src="$fincraftBasics.img.loading"/>
              </v-layout>
            </v-img>
            <p v-for="(item , index) in academyEntry.data.body[0].items" :key="index">
              {{ item.text[0].text }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </fin-data-loader>

</template>


<script>
import FinDataLoader from "@/components/common/DataLoader"

export default {
  name: "FinAcademyEntry",
  components: {FinDataLoader},
  props: {
    entryId: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      academyEntry: undefined
    }
  },
  methods: {
    async loadEntry() {
      this.academyEntry = await this.$prismic.client.getByID(this.entryId)
    }
  }
}
</script>

<style lang="scss" scoped>

.intro {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
}
</style>
